import React from 'react';

import { Input } from 'components/Misc/Form';
import Container from 'components/Misc/Container';

const Search = ({ search, onChange }) => {
	return (
		<Container className="p-4 flex gap-4">
			<Input
				name="title"
				placeholder="Nosaukums"
				value={search.title}
				onChange={onChange}
			/>
		</Container>
	);
};

export default Search;
